import React from 'react'
import Body from 'components/TemplateForm/Body'
import Footer from 'components/TemplateForm/Footer'

const AddOrEditTaskPage_Preview_Email = () => (
  <div>
    <Body borderRadius />
    <Footer />
  </div>
)

export default AddOrEditTaskPage_Preview_Email
